// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
// CUSTOM COMPONENTS
import Section from '../../components/Section';
import FormBlock from '../../components/FormBlock';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import InputBlock from '../../components/InputBlock';
import SelectBlock from '../../components/SelectBlock';
import TextAreaBlock from '../../components/TextAreaBlock';
import FileUploadBlock from '../../components/FileUploadBlock';
import CheckboxBlock from '../../components/CheckboxBlock';
import Button from '../../components/Button';
import LoadingScreen from '../../components/LoadingScreen';
// SERVICES AND HELPERS
import { Alert } from '../../helpers/Alert';
import * as Helper from '../../helpers/helper';
import * as CompanyService from '../../services/company.service';
import * as MediaTypeService from '../../services/mediatype.service';
import * as CategoryService from '../../services/category.service';
import CategoryCreateValidator from '../../helpers/validators/product-management/CategoryCreateValidator';

var timeoutId = 0;
var mediaTypeId = 0;

const CreateNewCategoryPage = (props) => {
    const role = Helper.LoggedInUserRole();
    const companyId = Helper.LoggedInCompanyId();

    const { location } = props
    const urlId = location.pathname.split('/').pop();
    const [categoryId, setCategoryId] = useState(parseInt(urlId) == urlId ? urlId : 0);
    const initialState = {
        id: categoryId,
        name: "",
        mediaTypeId: null,
        description: "",
        logoFile: [],
        imageFile: [],
        videoFile: [],
        videoLink: "",
        isActive: true,
        companyId: companyId
    }

    const [loading, setLoading] = useState(false);
    const [isChecking, setIsChecking] = useState(false);
    const [isUsed, setIsUsed] = useState(false);
    const [isDisabled, setIsDisabled] = useState(role == 'User');

    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(companyId);

    const [mediaTypes, setMediaTypes] = useState([]);
    const [selectedMediaType, setSelectedMediaType] = useState(null);

    const [category, setCategory] = useState(initialState);

    const [logoFile, setLogoFile] = useState(null);
    const [logoPath, setLogoPath] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [imagePath, setImagePath] = useState(null);
    const [videoFile, setVideoFile] = useState(null);
    const [videoPath, setVideoPath] = useState(null);

    useEffect(() => {
        setLoading(true);
        if (categoryId > 0) {
            CategoryService.Get(categoryId).then(res => {
                // need to figure out CORs before we return to this
                // setLogoFile([{
                //     source: res.logoPath,
                //     options: {
                //         type: 'local'
                //     }
                // }]);
                SetDataFromCategory(res);
                LoadCompanies(res.companyId);
                LoadMediaTypes(res.companyId);
            }).catch(ex => {
                setLoading(false);
            });
        }
        else
            LoadCompanies(selectedCompany);
    }, [])

    const LoadCompanies = (defaultCompanyId) => {
        if (role == "SuperAdmin") {
            CompanyService.GetAll().then(res => {
                setCompanies(res);
                let companySaved = res.find(x => x.id == defaultCompanyId);
                setSelectedCompany(Helper.SetOptionModel(companySaved.businessName, companySaved.id));
                setLoading(false);
            }).catch(ex => {
                setLoading(false);
            });
        }
        else
            LoadMediaTypes(companyId);
    }

    const LoadMediaTypes = (companyId) => {
        setLoading(true);
        setSelectedMediaType(null);
        MediaTypeService.GetAll(companyId).then(res => {
            setMediaTypes(res);
            if (mediaTypeId > 0) {
                let mediaTypeSaved = res.find(x => x.id == mediaTypeId);
                setSelectedMediaType(Helper.SetOptionModel(mediaTypeSaved.name, mediaTypeSaved.id))
            }
            setLoading(false);
        }).catch(ex => {
            setLoading(false);
        });
    }

    const SetDataFromCategory = (category) => {
        setLogoPath(category.logoPath);
        setImagePath(category.imagePath);
        setVideoPath(category.videoPath);
        mediaTypeId = category.mediaTypeId;
        setCategory(category);
        setCategoryId(category.id);
    }

    const DeleteCategoryImage = (path) => {
        CategoryService.DeleteCategoryImage(categoryId, path)
            .then(res => {
                Alert({success: true, message: 'Image has been removed!'});
            }).catch(ex => {});
    }

    const DeleteCategoryVideo = (key) => {
        CategoryService.DeleteCategoryVideo(categoryId, key)
            .then(res => {
                Alert({success: true, message: 'Video has been removed!'});
            }).catch(ex => {});
    }

    const checkName = (e) => {
        clearTimeout(timeoutId);
        setIsChecking(true);
        timeoutId = setTimeout(() => {
            formik.setFieldTouched('name');
            if (e != undefined && e.target.value == category.name) {
                setIsUsed(false);
                setIsChecking(false);
            }
            else
                CategoryService.Check(e == undefined ? formik.values.name : e.target.value, selectedCompany >= 0 ? selectedCompany : selectedCompany.value).then(res => {
                    setIsUsed(res);
                    setIsChecking(false);
                });
        }, 300);
    }

    const CreateCategory = (values, setSubmitting) => {
        if (isUsed)
            return;
        setLoading(true);
        setSubmitting(true);
        CategoryService.Save(Helper.ConvertJsonToFormData({
            ...values,
            videoPath: videoPath,
            logoFile: logoFile ? logoFile[0].file : null,
            imageFile: imageFile ? imageFile[0].file : null,
            videoFile: videoFile ? videoFile[0].file : null,
        })).then(res => {
            SetDataFromCategory(res);
            setSubmitting(false);
            setLoading(false);
            Alert({ success: true, message: "Category has been saved!" });
        }).catch(ex => {
            setSubmitting(false);
            setLoading(false);
        });
    }

    const formik = useFormik({
        initialValues: category,
        enableReinitialize: true,
        validationSchema: CategoryCreateValidator,
        onSubmit: (values, { setSubmitting }) => {
            CreateCategory(values, setSubmitting);
        }
    })

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <CustomBlock className="main-container light--bg">
                        <Section>
                            <CustomBlock className="content-container--card-style content">
                                <ContentHeader
                                    title={(categoryId == 0 ? "Add New " : "Update ") + "Category"}
                                    headerSize="sm"
                                />
                                <FormBlock onSubmit={formik.handleSubmit}>
                                    <Section removeContainer>
                                        {
                                            role == "SuperAdmin" ?
                                                <ContentBlock>
                                                    <SelectBlock
                                                        id="companyId"
                                                        name="companyId"
                                                        inputLabel="Company"
                                                        bordered
                                                        value={selectedCompany}
                                                        options={companies.map(x => Helper.SetOptionModel(x.businessName, x.id))}
                                                        onBlur={() => formik.setFieldTouched("companyId")}
                                                        onChange={option => {
                                                            option = option === null ? [] : option;
                                                            formik.setFieldValue("companyId", option.value);
                                                            setSelectedCompany(option);
                                                            LoadMediaTypes(option.value);
                                                        }}
                                                        inputState={
                                                            formik.touched.companyId && formik.errors.companyId
                                                                ? "error"
                                                                : formik.touched.companyId && formik.errors.companyId == null
                                                                    ? "success"
                                                                    : ""
                                                        }
                                                        errorMessage={formik.errors.companyId}
                                                    />
                                                </ContentBlock> : <></>
                                        }
                                        <ContentBlock cols={6}>
                                            <InputBlock
                                                id="name"
                                                inputLabel="Category Name"
                                                bordered
                                                {...formik.getFieldProps("name")}
                                                inputState={
                                                    selectedCompany == 0 ? "disabled" :
                                                        formik.touched.name && (formik.errors.name || isUsed)
                                                            ? "error"
                                                            : formik.touched.name && formik.errors.name == null && !isUsed ? "success" : ""
                                                }
                                                errorMessage={isUsed ? "Name is already in use!" : formik.errors.name}
                                                onKeyUp={checkName}
                                                loading={isChecking}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>
                                        <ContentBlock cols={6}>
                                            <SelectBlock
                                                id="mediaTypeId"
                                                name="mediaTypeId"
                                                inputLabel="Media Type"
                                                options={mediaTypes.map(x => Helper.SetOptionModel(x.name, x.id))}
                                                value={selectedMediaType}
                                                bordered
                                                onBlur={() => formik.setFieldTouched('mediaTypeId')}
                                                onChange={option => {
                                                    option = option === null ? [] : option;
                                                    setSelectedMediaType(option);
                                                    formik.setFieldValue("mediaTypeId", option.value);
                                                }}
                                                inputState={selectedCompany == 0 ? "disabled" : formik.touched.mediaTypeId && formik.errors.mediaTypeId ? "error" : formik.touched.mediaTypeId && formik.errors.mediaTypeId == null ? "success" : ""}
                                                errorMessage={formik.errors.mediaTypeId}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock>
                                            <TextAreaBlock
                                                id="description"
                                                inputLabel="Description"
                                                bordered
                                                {...formik.getFieldProps("description")}
                                                inputState={selectedCompany == 0 ? "disabled" : ""}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <FileUploadBlock
                                                clearAction
                                                path={logoPath}
                                                labelIdle='Upload Logo'
                                                onupdatefiles={setLogoFile}
                                                disabled={isDisabled}
                                                onClick={DeleteCategoryImage}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <FileUploadBlock
                                                clearAction
                                                path={imagePath}
                                                labelIdle='Upload Image'
                                                onupdatefiles={setImageFile}
                                                disabled={isDisabled}
                                                onClick={DeleteCategoryImage}
                                            />
                                        </ContentBlock>

                                        <ContentBlock>
                                            <FileUploadBlock
                                                clearAction
                                                type='video'
                                                setVideoPath={setVideoPath}
                                                videoUrl={videoPath}
                                                labelIdle='Upload Video'
                                                onupdatefiles={setVideoFile}
                                                disabled={isDisabled}
                                                onClick={DeleteCategoryVideo}
                                            />
                                        </ContentBlock>

                                        {/* <ContentBlock>
                                            <InputBlock
                                                id="videoLink"
                                                inputLabel="Video Link"
                                                bordered
                                                {...formik.getFieldProps("videoLink")}
                                                inputState={selectedCompany == 0 ? "disabled" : ""}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock> */}

                                        <ContentBlock className="padding-vertical">
                                            <CheckboxBlock
                                                label="Is category active?"
                                                id="is-active-checkbox"
                                                defaultChecked={formik.values.isActive}
                                                {...formik.getFieldProps("isActive")}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <CustomBlock className="content-container--actions">
                                            <Button
                                                text="Cancel"
                                                to="/categories"
                                                className="danger--bg fit-content"
                                            />
                                            {
                                                role == 'User' ? <></> :
                                                    <Button
                                                        text="Save"
                                                        type="submit"
                                                        className="success--bg fit-content"
                                                    />
                                            }
                                        </CustomBlock>
                                    </Section>
                                </FormBlock>
                            </CustomBlock>
                        </Section>
                    </CustomBlock>
            }
        </>
    );
}

export default CreateNewCategoryPage;